export const openMessangerWindow = () => {
    document.querySelector('[id*=gb-widget] a[target*=blank]').click()
};